export default {
    login: {
        first: 'Creamos solución de sensor',
        second: 'para usted.',
        third: 'Nuestro diseño simple pero inteligente le proporcionará las herramientas para convertir los datos en tiempo real en un rendimiento comercial inmediatamente mejorado.',
        first_flower: 'we colour the public space with our durable plant concepts',
        second_flower: '',
        third_flower: 'We provide flowering public green spaces and large gardens throughout Europe. We do this by supplying and planting flower bulbs, wild flowers and perennials.',
        desc: 'Inicie sesión ingresando la información a continuación',
        username: 'Email',
        password: 'Contraseña',
        successful: 'Inicio de sesión correcto',
        logout: 'Cerrar sesión',
        login: 'Iniciar',
        in: 'sesión',
    },
    dashboard: {
        title: 'Tablero',
        search: 'Buscar',
        no_lora_id: 'Sin identificación LoRa',
        dealer_view: 'Dealer view',
        nav: {
            type: 'Tipo',
            batch: 'Calibración',
            location: 'Ubicación',
            remark: 'Observación',
            lqi: 'Enlace',
            lqi_hover: 'Indicador de calidad de enlace',
            unit: 'Tentacle',
            last_event: 'Último evento',
            l_update: 'Últimos datos',
            timing: 'Sincronización dinámica',
            sensing: 'Ajustes avanzados',
            notification: 'Alertas',
            customer: 'Cliente',
            favourite: 'Favorito',
        },
        bulk_setup: {
            substrate_properties: 'Propiedades del sustrato',
            frame_selection: 'Elección del marco de referencia',
            critical_value: 'Umbrales de notificación',
            payload_error: 'El formato de carga útil de los dispositivos seleccionados no es idéntico',
            hundred_tx_power: 'Calculado para una potencia de transmisión del 100%.',
            version_error: 'Levensduurberekening alleen beschikbaar voor apparaten met identieke uitvoeringen.',
            sa_error: 'El cálculo de la vida útil solo está disponible para dispositivos sin autoconocimiento (consulte la página de detalles del dispositivo).',
            sa_version_error: 'El cálculo de la vida útil solo está disponible para dispositivos con versiones idénticas sin conocimiento propio (consulte la página de detalles del dispositivo para obtener información sobre la vida útil del dispositivo).',
            version_identical_sa_error: 'La selección de perfil solo está disponible para dispositivos con la misma versión.',
            batch_type_error: 'El tipo de calibración del tentáculo no es idéntico (propiedades deshabilitadas)',
            batch_missing_error: 'La calibración de uno o más tentáculos no está configurada (propiedades deshabilitadas)',
            batch_all_error: 'Para continuar, configure todas las propiedades',
            affected: 'Cambio aplicado a {count} dispositivos',
            identical_version_error: 'Seleccione dispositivos con versiones idénticas para la edición masiva (no es posible cambiar el intervalo de medición).',
            measurement_interval_cant: 'Cambio de intervalo de medición no disponible.',
            measurement_sets_cant: 'La acumulación, el intervalo de enlace descendente y los cambios de reintentos de enlace descendente no están disponibles.',
            sa_active_error: 'Seleccione dispositivos sin perfil de autoconciencia activo para cambiar \'Acumulación\', \'Intervalo de enlace descendente\' y \'Reintentos de enlace descendente\'',
            sa_mixed_error: 'Seleccione solo dispositivos con o sin perfil de autoconciencia activo para editar la selección de fotogramas (combinación no posible).',
            expert_mode: '*¡¡Modo experto habilitado!! Mostrando todas las opciones mientras la autoconciencia está habilitada.',
            data_auto_scaling: '*¡Escalado Automático de Datos habilitado! Sensor usando Coeficientes de Escala de Calibración. ',
        },
        remark: {
            double_click: 'Doble clic',
            to_add: 'para agregar valor',
            history: 'Historial de comentarios',
            show_history: 'Mostrar historial de comentarios',
        },
    },
    map: {
        calculated: 'Ubicación calculada',
        manual: 'Colocación manual',
    },
    detail: {
        new_calib_point: 'Agregar nuevo punto de calibración',
        remove_calib_point: 'Quitar el punto de calibración',
        raw_value: 'Valor bruto',
        calibrate_min: 'Calibrar min.',
        calibrate_max: 'Calibrar máx.',
        apply_calib: 'Aplicar calibración a las propiedades',
        reset_minmax: 'Restablecer valores mínimos y máximos',
        reset_calib: 'Restablecer a la calibración asignada',
        select_props: 'Seleccione las propiedades para calibrar',
        save_props: 'Guardar en propiedades seleccionadas',
        percent: 'VWC',
        batch: 'Calibración',
        selected_batch: 'Calibración seleccionado',
        raw: 'Raw',
        warning: 'Advertencia',
        warning_vwc: 'El valor de VWC o el equivalente RAW no es válido. Corrija los valores para que sean superiores al mínimo, inferiores al máximo o cualquier otro valor que no exista.',
        measured_min: 'Mínimo medido',
        measured_max: 'Máximo medido',
        select_props: 'Seleccionar propiedades',
        lqi: 'La calidad del enlace',
        lqi_calculated: 'Calculado utilizando estaciones base.',
        map: 'Ubicación del sensor',
        sensor_setting: 'Ajustes del sensor',
        etentacles_setting: 'Configuración de iTentacles',
        min_value: 'Valor mínimo',
        last_value: 'Último valor',
        max_value: 'Valor máximo',
        select_data: 'Seleccionar datos',
        missing: 'Datos no disponibles',
        moisture_calibration: 'Calibración VWC',
        warning_batch_calibration: '¡Advertencia! ¡Está actualizando la calibración asignada!',
        warning_device_calibration2: '¡Advertencia! Para aplicar la calibración a las propiedades, haga clic en "Aplicar calibración a las propiedades"',
        device_only_label: 'Calibrar solo para dispositivo',
        payload_format: 'Marco de carga (dispositivo)',
        payload_format_change: 'Cambiar el marco de medición',
        payload_format_not_set: 'Aún no actualizado',
        payload_format_changed: 'Ultimo cambio',
        payload_format_updated: 'Última actualización',
        format: 'Marco de referencia',
        set_format: 'Establecer marco',

        dynamic_sensing: 'Ajustes avanzados',
        measurement_frame: 'Marco de medición',
        none: 'Ninguno',
        moisture: 'Humedad',
        temperature: 'Temperatura',
        light: 'Luz',
        measurement_sets: 'Conjuntos de medidas acumulados',
        measurement_interval: 'Intervalo de medición',
        sigfox_frames_transmitted: 'Marcos Sigfox transmitidos',
        lora_connections: 'Conexión/red Lora',
        downlik_period: 'Período de enlace descendente',
        downlink_retries: 'Reintentos de enlace descendente',
        transmitting_power: 'Transmisión de poder',
        message_interval: 'Intervalo de mensajes',
        sigfox_device_lifespan: 'Duración de la batería del dispositivo SigFox',
        device_lifespan: 'Duración de la batería del dispositivo',
        device_loralifespan: 'Duración del dispositivo LoRa',
        downlink_max: 'Max efficiency',
        once_per_four: 'Una vez cada 4 días',
        once_per_two: 'Una vez cada 2 días',
        once_per_day: 'Una vez al día',
        twice_per_day: 'Dos veces al dia',
        set_dynamic_sensing: 'Eestablecer configuraciones avanzadas',
        sa_title: 'Conciencia de sí mismo',
        sa_select_profile: 'Perfil activo',
        sa_enable_profile: 'Establecer perfil',
        sa_hover: 'Según el perfil, la configuración del dispositivo se cambia según el estado de comunicación/conexión.',
        sa_automatic_mode: '*Las opciones gestionadas por la autoconciencia están ocultas.',
    },
    lqi: {
        Excellent: 'Excelente',
        Good: 'Buena',
        Average: 'Promedio',
        Limit: 'Limitada'
    },
    server_status: {
        title: 'Página de estado del servidor',
    },
    privacy: {
        title: 'Política de privacidad',
    },
    sigfox_coverage: {
        title: 'Cobertura de señal',
        coverage_error: 'Error del servicio de cobertura',
        unstable: 'No hay cobertura y es posible que el dispositivo no se sincronice.',
        works_underground: 'El vínculo es fuerte y el dispositivo debe funcionar bajo tierra o en interiores profundos.',
        possible_underground: 'El vínculo es lo suficientemente fuerte para la posibilidad de trabajar bajo tierra o en interiores profundos.',
        works_indoor: 'El enlace es estable y el dispositivo debería funcionar en interiores (es posible que no funcione bajo tierra).',
        possible_indoor: 'El enlace es lo suficientemente estable para la posibilidad de trabajar en interiores. (puede que no funcione bajo tierra).',
        works_open: 'Es posible que el enlace no sea estable y el dispositivo debería funcionar en campo abierto.',
        possible_open: 'El dispositivo obtuvo un enlace y existe la posibilidad de que el dispositivo funcione en campo abierto.',
        coverage_env: "Colocación del dispositivo",
        coverage_env_greenhouse: "Invernadero",
        coverage_env_indoors: "Adentro",
        coverage_env_outdoors: "Al aire libre",
    },
    payload: {
        title: 'Carga útil del Soil 3XS',
    },
    export: {
        limit: 'Elige los últimos x valores de los tentáculos seleccionados',
        info: {
            first: 'Exportar',
            second: 'seleccionado',
            rest: 'Primero seleccione algunas unidades de la tabla',
        },
        tabs: {
            date_range: 'Rango de fechas',
            limit_values: 'Límite',
        },
    },
    contact_us: {
        title: 'Contáctenos',
        subj: 'Asunto',
        mess: 'Mensaje',
    },
    tooltips: {
        customer: 'Mostrando dispositivos asignados a este cliente.',
        logout: 'Cerrar sesión',
        total_units: 'Unidades totales',
        unit_name: 'Nombre de la unidad',
        excel: 'Exportar Excel',
        csv: 'Exportar CSV',
        search: 'o presione',
        tentacle_missing: 'elige al menos un tentacle',
        network: 'cambiar la ID externa de la red mostrada',
    },
    buttons: {
        ok: 'Ok',
        login: 'Iniciar sesión',
        detail: 'Detalle',
        apply: 'Aplicar los cambios',
        apply_range: 'Aplicar rango',
        bulk: 'Configuración masiva',
        bulkdetail: 'Detalle del grupo',
        cancel: 'Cancelar',
        send: 'Enviar',
        export: 'Export',
        delete_range: 'Eliminar rango',
        next: 'Siguiente página',
        previous: 'Pagina anterior',
        save: 'Archivo',
    },
    metrics: {
        moisture: 'VWC',
        moisture_top: 'VWC superior',
        moisture_middle: 'VWC medio',
        moisture_bottom: 'VWC inferior',
        light: 'Luminosidad',
        temperature: 'Temperatura',
        battery: 'Batería',
        pressure: 'Presión',
        pump_mode: 'Bomba en funcionamiento',
        gyroscope: 'Vibraciones',
        events: 'Eventos',
        currents: 'Corriente de fase',
        angles: 'Ángulo de fase',
        over_vibration_stop: 'Parada de vibración excesiva',
    },
    timing: {
        t1: '15 minutos',
        t2: '30 minutos',
        t3: '1 hora',
        t4: '2 horas',
        t5: '8 horas',
        t6: 'Apagado',
    },
    interval: {
        day: 'día',
        week: 'por semana',
        month: 'por mes',
        year: 'por año',
    },
    notifications: {
        push: 'Alertas',
    },
    sensing: {
        sens1: 'Corriente Soil 3XT-4',
        sens2: 'Original 2x por hora',
        sens3: 'Humedad 4x por hora',
        sens4: 'Humedad 3x por 45 min',
        sens5: 'Humedad/Temp 2x por 30 min',
        sens6: 'Humedad/Temp/Ligero 2x por 30 min',
    },
    info: {
        loading_data: 'Cargando datos'
    },
    eventChart: {
        networkGatewaysCreated: 'Aprovisionamiento a la red',
        networkGatewayActive: 'Dispositivo ENCENDIDO',
        networkGatewayRemoved: 'Eliminar de la red',
        fportSettingsChange: 'Cambio de configuración avanzada de LoRa',
        activeGatewayChange: 'Red modificada',
        networkChangeRequest: 'Cambio de red',
        networkDownlinkLimit: 'Límite de enlaces descendentes',
        fportSettingsChange101Message: 'Configuración agregada del dispositivo actualizada',
        fportSettingsChange102Message: 'Tasas de datos LoRa del dispositivo actualizadas',
        fportSettingsChange103Message: 'Configuración de retransmisión del dispositivo actualizada',
        activeGatewayChangeMessage: 'La red del dispositivo {previous} cambió a {active}',
        networkChangeRequestMessage: 'La red del dispositivo {previous} cambia a {new}',
        networkDownlinkLimitMessage: 'Se ha alcanzado el límite de downlinks de LoRa. El próximo downlink disponible (configuración) será mañana.',
        networkGatewaysCreatedMessage: 'El dispositivo ha sido aprovisionado para las redes [{networks}]',
        networkGatewayActiveMessage: 'El dispositivo envió los primeros datos en la red {network}',
        networkGatewayRemovedMessage: 'El dispositivo se eliminó de la red {network}',
        sequenceMessage: 'El número de secuencia esperado era {previous} vino {actual}',
        ensBackupMessage: 'ENS ha cambiado la red a {network} debido a la indisponibilidad de la red.',
        ensSequenceMessage: 'ENS ha cambiado la red a {network} debido a un mensaje faltante.',
        ansRegularMessage: 'ANS ha cambiado la red a {network} debido a una mala conexión de red.',
        ansExecutionMessage: 'ANS/ENS ha seleccionado la red {network}.',
        lqiMessage: 'Lqi es bajo para mensajes {badCount} pasados. El último fue "{lqi}"',
        invalidMessage: 'Dispositivo enviando datos incorrectos',
        ackMessage: 'La actualización esperada del dispositivo fue {expectedAt}',
        sequence: 'Número de secuencia faltante',
        lqi: 'LQI bajo',
        power: 'Cambio de potencia de transmisión',
        settings: 'Instellingen gewijzigd',
        invalid: 'Datos inválidos',
        pendingChange: 'Cambio pendiente',
        pendingChangeMessage: 'El dispositivo todavía no ha aplicado la configuración modificada.',
        verifiedChange: 'Cambio verificado',
        verifiedChangeMessage: 'Configuraciones del dispositivo verificadas cambiadas por downlink.',
        ack: 'Configuración no aplicada',
        info: 'Información',
        warning: 'Advertencia',
        error: 'Error',
        latestEvent: 'Último Evento',
        sigfoxDeleted: 'Estado de nube apagada',
        sigfoxCreated: 'Estado de nube activada',
        deviceOn: 'Dispositivo ENCENDIDO',
        sigfoxDeletedMessage: 'El dispositivo en la nube está configurado en estado APAGADO',
        sigfoxCreatedMessage: 'El dispositivo en la nube está configurado para activar el estado',
        deviceOnMessage: 'El dispositivo envió los primeros datos en la red SigFox',
        events: 'Eventos',
        message: 'Mensaje',
        default: 'Por defecto',
        changedBy: 'Cambiado por {name}',
        customer: 'Cambio de cliente',
        calibration: 'Calibración cambiada',
        calibrationMessage: 'Los ajustes de calibración cambian.',
        customerMessage: 'El cliente ha sido cambiado a {name}.',
        baseCalibrationMessage: 'La calibración base ha cambiado a {calibration}.',
        propertiesCalibrationMessage: 'La calibración ha cambiado a {properties}.',
        powerMessage: 'La configuración de transmisión del dispositivo cambió.',
        transmittingMessage: 'La potencia de transmisión cambió de {previous} a {actual}.',
        periodMessage: 'El período cambió de "{previous}" a "{actual}".',
        networkTypesMessage: 'El tipo de red cambió de "{previous}" a "{actual}".',
        sfFramesMessage: 'Las tramas de transmisión de Sigfox cambiaron de "{previous}" a "{actual}".',
        spanMessage: 'El intervalo de medición ha cambiado de {previous} a {actual} minutos.',
        retriesMessage: 'El número de reintentos cambió de {previous} a {actual}.',
        settingsMessage: 'La configuración del dispositivo cambió.',
        frameMessage: 'El marco ha cambiado de "{previous}" a "{actual}".',
        intervalMessage: 'El intervalo ha cambiado de {previous} a {actual} minutos.',
        accumulationMessage: 'La acumulación ha cambiado de {previous} a {actual} mensajes.',
        thresholdMessage: 'El dispositivo midió valores críticos.',
        criticalMessage: 'Se alcanzó el valor crítico del sensor {sensor} de {value}{unit} (umbral establecido {threshold}{unit}).',
        threshold: 'Valor crítico',
        attentionMessage: 'El dispositivo midió los valores de atención.',
        notificationMessage: '{sensor} valor de atención del sensor de {value}{unit} alcanzado (umbral establecido {threshold}{unit}).',
        attention: 'Valor de atención',
        selfAwarenessChange: 'Conciencia de sí mismo',
        selfAwarenessChangeTooltipSequence: 'Configuración de autoconocimiento aplicada.',
        selfAwarenessChangeTooltipLqi: 'Configuración de autoconocimiento aplicada.',
        selfAwarenessChangeTooltipStandby: 'Configuración de autoconciencia ignorada.',
        selfAwarenessChangeTooltipVwc: 'Configuración de autoconocimiento ignorada.',
        selfAwarenessChangeMessageSequence: 'Se detectó un mensaje faltante y se ejecutó la configuración de autoconciencia para el perfil {state} {profile}.',
        selfAwarenessChangeMessageLqi: 'Coincidió con el LQI de {number} {lqi} y ejecutó la autoconciencia en el perfil de {state} {profile}.',
        selfAwarenessChangeMessageStandby: 'La ejecución de autoconocimiento se omitió porque el dispositivo está en modo de espera.',
        selfAwarenessChangeMessageVwc: 'La ejecución de autoconciencia se omitió porque el dispositivo midió el VWC por debajo del 5 %.'
    },
    transmittingPower: {
        15: "125%",
        14: "100%",
        13: "80%",
        12: "65%",
        11: "50%",
        10: "40%",
        9: "33%",
        8: "25%",
        7: "20%"
    },
    downlinkPeriods: {
        0: {
            25: "Una vez cada 4 días",
            5: "Una vez cada 2 días"
        },
        1: "Una vez al día",
        2: "Dos veces al dia"
    },
    networkTypes: {
        1: "Sólo Sigfox",
        2: "Sólo LoRa",
        3: "Prioridad Última conexión",
        4: "Prioridad SigFox",
        5: "Prioridad LoRa"
    },
    sfFrames: {
        1: "Un cuadro",
        2: "Tres fotogramas"
    },
    sensors: {
        Moist: 'VWC',
        light: 'Luminosidad',
        temp: 'Temperatura',
        battery: 'Batería'
    },
    slider: {
        header: {
            attention: 'Atención',
            critical: 'Crítico'
        }
    },
    header: {
        custom_name: "Nombre personalizado",
        generic_name: "Nombre genérico",
        network_sigfox: "Sigfox",
        network_lora: "LoRa",
    },
    network: {
        active_network: 'Red activa',
        null: 'Desconocido',
        sigfox: 'Sigfox',
        helium: 'Helium',
        skynet: 'SkyNet',
    }
};
